// extracted by mini-css-extract-plugin
export var closed = "_b8-1";
export var resizer = "_b8-0";